import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = { class: "flex flex-row items-stretch justify-between w-full" }
const _hoisted_3 = { class: "flex items-center justify-end gap-5 w-full mt-5" }
const _hoisted_4 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_5 = { class: "text-center py-5" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Step = _resolveComponent("Step")
  const _component_StepList = _resolveComponent("StepList")
  const _component_BankDetail = _resolveComponent("BankDetail")
  const _component_StepPanel = _resolveComponent("StepPanel")
  const _component_StepPanels = _resolveComponent("StepPanels")
  const _component_Stepper = _resolveComponent("Stepper")
  const _component_Toast = _resolveComponent("Toast")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isBankUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-white text-xl font-bold" }, "อัปเดตบัญชี", -1 /* HOISTED */)),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "กรุณาอัปเดตบัญชีธนาคาร", -1 /* HOISTED */)),
          _createVNode(_component_Button, {
            label: "อัปเดตบัญชี",
            onClick: _ctx.btnClickUpdateBank,
            class: "mt-4",
            size: "small"
          }, null, 8 /* PROPS */, ["onClick"])
        ]))
      : (_openBlock(), _createBlock(_component_Stepper, {
          key: 1,
          value: _ctx.stepper,
          linear: "",
          pt: {separator:'bg-black!'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StepList, null, {
              default: _withCtx(() => [
                _createVNode(_component_Step, {
                  value: "1",
                  pt: {header: 'text-xs!', number: 'text-black! text-xs! size-6! min-w-auto!', title:'text-white!'}
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("ฝาก")
                  ])),
                  _: 1 /* STABLE */,
                  __: [2]
                }),
                _createVNode(_component_Step, {
                  value: "2",
                  pt: {header: 'text-xs!', number: 'text-black! text-xs! size-6! min-w-auto!', title:'text-white!'}
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("สำเร็จ")
                  ])),
                  _: 1 /* STABLE */,
                  __: [3]
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_StepPanels, { pt: {root: 'px-0!'} }, {
              default: _withCtx(() => [
                _createVNode(_component_StepPanel, {
                  value: "1",
                  pt: {root: 'bg-transparent!'}
                }, {
                  default: _withCtx(({ activateCallback }) => [
                    (_ctx.isActive)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bg-[#00a269bf]! border-2! border-[#13ff80] rounded-lg mb-3 p-1" }, [
                            _createElementVNode("p", { class: "text-white text-[16px]" }, "⚠️ ฝากขั้นต่ำ 100 บาท"),
                            _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "หากโอนยอดต่ำกว่า 100 บาท เงินจะไม่เข้าอัตโนมัติ ต้องติดต่อแอดมินเพื่อแจ้งปรับยอดเงิน")
                          ], -1 /* HOISTED */)),
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_BankDetail, {
                              isActivate: _ctx.bankAccount.active,
                              loading: _ctx.bankAccount.loading,
                              bank: _ctx.bankAccount.data
                            }, null, 8 /* PROPS */, ["isActivate", "loading", "bank"]),
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex items-center w-max" }, [
                              _createElementVNode("svg", {
                                class: "text-gray-800",
                                "aria-hidden": "true",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                fill: "none",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  stroke: "currentColor",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 12H5m14 0-4 4m4-4-4-4"
                                })
                              ])
                            ], -1 /* HOISTED */)),
                            _createVNode(_component_BankDetail, {
                              isCopyNumber: true,
                              isActivate: _ctx.bankDeposit.active,
                              loading: _ctx.bankDeposit.loading,
                              bank: _ctx.bankDeposit.data
                            }, null, 8 /* PROPS */, ["isActivate", "loading", "bank"])
                          ]),
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_Button, {
                              onClick: $event => (activateCallback('2')),
                              size: "small",
                              label: "ถัดไป",
                              disabled: (!_ctx.bankAccount.active) || (!_ctx.bankDeposit.active),
                              class: "bg-[#313131] border-transparent"
                            }, null, 8 /* PROPS */, ["onClick", "disabled"])
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[6] || (_cache[6] = [
                          _createElementVNode("h2", { class: "text-[#10b981] text-xl font-bold" }, "ปิดให้บริการชั่วคราว", -1 /* HOISTED */),
                          _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "ช่องทางฝากนี้ ปิดให้บริการชั่วคราวกรุณาลอง ช่องทางอื่นๆ", -1 /* HOISTED */)
                        ])))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_StepPanel, {
                  value: "2",
                  pt: {root: 'bg-transparent!'}
                }, {
                  default: _withCtx(({ activateCallback }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-[#10b981] text-xl font-bold" }, "เมื่อทำการโอนเงินเรียบร้อยแล้ว", -1 /* HOISTED */)),
                      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "ยอดเงินจะถูกเติมเข้า กระเป๋าเกม ภายใน 5 วินาที", -1 /* HOISTED */)),
                      _createVNode(_component_Button, {
                        label: "กลับหน้าหลัก",
                        onClick: $event => (activateCallback('1')),
                        class: "bg-[#313131] border-transparent mt-4"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["value"])),
    _createVNode(_component_Toast)
  ], 64 /* STABLE_FRAGMENT */))
}